<button class="align-vertical" [disabled]="disabled()" [matTooltip]="tooltip() || label()">
  <mat-icon>{{ icon() }}</mat-icon>
  <div>{{ label() }}</div>
</button>
